import { render, staticRenderFns } from "./ListAddress.vue?vue&type=template&id=b4c6e6f2&scoped=true&"
import script from "./ListAddress.vue?vue&type=script&lang=js&"
export * from "./ListAddress.vue?vue&type=script&lang=js&"
import style0 from "./ListAddress.vue?vue&type=style&index=0&id=b4c6e6f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4c6e6f2",
  null
  
)

export default component.exports